import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["UpdatesTabs"] */ "/vercel/path0/web/app/(marketing)/updates/updates-tabs.tsx");
